import { OrderPlanningUnseatedTractor } from "../../planning/OrderPlanningUnseatedTractor";
import { DataSource, Label, Layout, Location, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSeatingDriver extends Layout {
    labelAddress: Label;
    labelCSZ: Label;
    labelDriverSummary: Label;
    labelLocationId: Label;
    labelLocationName: Label;
    labelSelectYourTractor: Label;
    labelYourTractorIsLocatedHere: Label;
    layoutOrderPlanningUnseatedTractor: OrderPlanningUnseatedTractor;
    locationTractor: Location;
    sourceSeating: DataSource;
    sourceUnseatedTractor: DataSource;
    textboxDate: Textbox;
    textboxDriverSeated: Textbox;
    textboxDriverTwo: Textbox;
    textboxTractor: Textbox;
}
